import React, { useState, useEffect, useContext } from "react";
import Advertise from "./Advertise";
import "./Css/GamePreview.css"; // Adjust the path as necessary
import "./Css/Progress.css";
import "./Css/Loader.css";
import { useParams, useLocation } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import IsoPlayStoreLink from "./IsoPlayStoreLink";

import MetaTag from "./MetaTag";
import axios from "axios";
import LikedGame from "./LikedGame";
import GameSidebar from "./GameSidebar";
const GamePreview = ({ setNewClass }) => {
  const { gamePath } = useParams();
  const [loading, setLoading] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  //const [gameIframe, setGameIframe] = useState(false);

  const imgName = gamePath ? gamePath.replace(/-/g, " ") : ""; // Replace hyphens with spaces for the image name

  const {
    gameUrl,
    addGameUrl,
    thumbnailImg,
    addThumbImg,
    pageType,
    setgametype,
    setpagetype,
    pageRefresh,
    setPageRefreshCount,
    gametitle,
    setgametitle,
    metadata,
    AppStoreLink,
    baseUrl,
    setmetadata,
    setappstorelink,
    setCategory,
    setdescreption,
    setgameid,
    Backend_folder_path,
    gameIframe,
    setGameIframeStatus,
    thumb_img,
    setThumbImgStatus,
  } = useContext(AppContext);
  const location = useLocation();
  const handleGame = async () => {
    setLoading(true);
    setThumbImgStatus(false);
    setGameIframeStatus(true);
    setNewClass("game-active");
    sessionStorage.setItem("countPage", 0);
    setPageRefreshCount(0);
    setpagetype("game_main_screen");
  };
  const onRefreshIframe = () => {
    let gUrl = JSON.parse(sessionStorage.getItem("gameurl"));
    setGameIframeStatus(false);
    setGameIframeStatus(true);
    addGameUrl("");
    //when user refrsh button on uframe title btn
    setTimeout(() => {
      addGameUrl(gUrl);
    }, 500);
  };

  useEffect(() => {
    if (gameUrl) {
      sessionStorage.setItem("gameurl", JSON.stringify(gameUrl));
      sessionStorage.setItem("thumbnailImg", JSON.stringify(thumbnailImg));
      sessionStorage.setItem("gametitle", gametitle);

      if (sessionStorage.getItem("countPage") == 0) {
        sessionStorage.setItem("countPage", 0);
      }
    }
    if (gameUrl == null) {
      let gUrl = JSON.parse(sessionStorage.getItem("gameurl"));
      let imgPATH = JSON.parse(sessionStorage.getItem("thumbnailImg"));
      let pageTYPE = sessionStorage.getItem("pagetype");
      let gametitle = sessionStorage.getItem("gametitle");

      let refreshCount = Number(sessionStorage.getItem("countPage")) + 1;
      //to stop game when user refresh browser more than 3 times
      if (refreshCount == 3) {
        setPageRefreshCount((prev) => prev + 1);
        let relatedGame = JSON.parse(sessionStorage.getItem("relatedGameList"));
      }
      sessionStorage.setItem("countPage", refreshCount);

      addGameUrl(gUrl);
      addThumbImg(imgPATH);
      setgametitle(gametitle);

      //clode add when browser refresh
    }
    // window.GameSDK.showInterstitialAd({
    //   id: thumbnailImg,
    //   url: gameUrl,
    //   thumb_img: thumbnailImg,
    //   title: gametitle,
    // });
  }, [gameUrl]);
  //call only when user hit the game in browser url directly
  const getGameByUrl = async (bowserPath) => {
    try {
      const response = await axios.get(`${baseUrl}/gamebyurl/${bowserPath}`);
      const game = response.data.data[0];
      if (game) {
        const path = `${Backend_folder_path}${game.folder_path}/index.html`;
        const thumb_img = `${Backend_folder_path}${game.thumbnail_img_path}`;

        addThumbImg(thumb_img);
        setCategory(game.category);
        setpagetype("gamePage");
        setgametitle(game.title);
        setdescreption(game.description);
        setgametype(game.gameType);
        setgameid(game.gameId);

        setmetadata({
          title: game.meta_title,
          keywords: game.meta_keyword,
          descreption: game.meta_description,
        });
        setappstorelink({
          ...AppStoreLink,
          iso_link: game.iso_link,
          playstore_link: game.playstore_link,
        });
        addGameUrl(path);
      }
    } catch (err) {
      console.error("Error fetching games:", err);
    }
  };
  useEffect(() => {
    if (gameUrl == null) {
      const bowserPath = location.pathname.split("/")[2];
      if (bowserPath) {
        getGameByUrl(bowserPath);
      }
    }
  }, [location]);
  return (
    <>
      {metadata.title && metadata.keywords && (
        <MetaTag
          title={metadata.title}
          keywords={metadata.keywords}
          descreption={metadata.descreption}
        />
      )}
      {thumb_img && (
        <div className="preview-container" style={{ position: "relative" }}>
          <img className="main-game-img" src={thumbnailImg} alt="fan" />
          <button onClick={() => handleGame()} className="play-btn">
            ▶ Play Now
          </button>
          <div className="game-meta">
            <strong>{imgName}</strong> &nbsp;👍 77% (69)
          </div>
        </div>
      )}

      {gameIframe && (
        <div className="game_main">
          <div
            className={isFullscreen ? "game-iframe" : "iframe-container"}
            style={{ height: "70vh" }}
          >
            {!isFullscreen && (
              <div className="game_header">
                <div>{imgName}</div>
                <LikedGame />
                <div className="inner">
                  <div>
                    <img
                      onClick={() => setIsFullscreen(true)}
                      src="/game_fullscreen.webp"
                    />
                  </div>
                  <div className="refresh-page">
                    <img
                      onClick={() => onRefreshIframe()}
                      src="/refreshBt.webp"
                    />
                  </div>
                </div>
              </div>
            )}
            {isFullscreen && (
              <button
                onClick={() => setIsFullscreen(false)}
                className="fullscreenBt"
              >
                x
              </button>
            )}

            <iframe
              style={{
                width: "100%",
                height: isFullscreen ? "100%" : "100%",
                border: "none",
                paddingBottom: "25px",
              }}
              title="Game Preview"
              src={gameUrl}
              frameBorder="0"
              allowFullScreen
            ></iframe>

            {/* <Loader loading={loading} progress={progress}/> */}
          </div>

          <IsoPlayStoreLink
            isoLink={AppStoreLink.iso_link}
            playStoreLink={AppStoreLink.playstore_link}
          />
        </div>
      )}
    </>
  );
};

export default GamePreview;
